import React from "react";
import { openCookieModal } from "../cookies/CookieConsentModal";

const Footer = () => {
  return (
    <>
      <div className="shane_tm_section">
        <div className="shane_tm_copyright">
          <div className="container">
            <div className="inner">
              <p>
                 {new Date().getFullYear()} &copy; {" "}
                <a
                  href="https://www.facebook.com/share/1DhqyGkbst/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Štěpán Juránek
                </a>
              </p>
              <button onClick={openCookieModal} >
                Nastavení cookies
              </button>
            </div>
            {/* End inner */}
          </div>
        </div>
        {/* End shane_tm_copyright */}
        
      </div>
    </>
  );
};

export default Footer;
